import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'

const state = {
  userSignedIn: localStorage.getItem('userToken') !== null,
  currentUser: null,
  otherUser: null,
  currentUserCommunityIDs: [],
  currentUserCommunities: null,
  otherUserCommunityIDs: [],
  otherUserCommunities: null
}

// getters
const getters = {
  getUserName: state => {
    if (state.currentUser !== null) {
      return state.currentUser.first_name + ' ' + state.currentUser.last_name
    } else {
      return 'not set'
    }
  },
  getUserEmail: state => {
    return state.currentUser.email
  },
  getUserCommunityIDstring: state => {
    if (state.currentUserCommunities !== null) {
      return state.currentUserCommunities.map(x => x.id).join();
    } else {
      return ''
    }
  },  
  getUserCommunityIDs: state => {
    if (state.currentUserCommunities !== null) {
      return state.currentUserCommunities.map(x => x.id)
    }
  },
  getProfileDetails: state => {
    state.userSignedIn = localStorage.getItem('userToken') !== null
    if (state.userSignedIn && state.currentUser !== null) {
      return {
        id: state.currentUser.id,
        name: state.currentUser.first_name + ' ' + state.currentUser.last_name,
        profilePic: state.currentUser.meta.thinktankProfileImage,
        employeeNumber: state.currentUser.meta.employeeNumber,
        communities: state.currentUserCommunities,
        department: state.currentUser.meta.department,
        country: state.currentUser.meta.country,
        isAdmin: state.currentUser.roles.indexOf('administrator') > -1 || state.currentUser.roles.indexOf('thinktank_admin') > -1,
        email: state.currentUser.email,
        username: state.currentUser.username,
        slug: state.currentUser.slug
      }
    } else {
      return 'user data not available'
    }
  },
  getOtherUserProfileDetails: state => {
    if (state.otherUser !== null) {
      return {
        id: state.otherUser.id,
        name: state.otherUser.name,
        profilePic: state.otherUser.meta.thinktankProfileImage,
        employeeNumber: state.otherUser.meta.employeeNumber,
        communities: state.otherUserCommunities,
        department: state.otherUser.meta.department,
        country: state.otherUser.meta.country,
        isAdmin: false
      }
    } else {
      return 'user data not available'
    }
  },
  isAdmin: state => {
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('administrator') > -1 || state.currentUser.roles.indexOf('thinktank_admin') > -1
    } else {
      return false
    }
  },
  isLinkAdmin: state => {
    if (state.userSignedIn && state.currentUser !== null) {
      console.log(' state.currentUser.roles ', state.currentUser.roles, state.currentUser.roles.indexOf('linkadmin'))
      return state.currentUser.roles.indexOf('linkadmin') > -1
    } else {
      return false
    }
  },
  isEEManager: state => {
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('equity_manager') > -1
    } else {
      return false
    }
  },
  viewAllNominationReport: state => {
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('all_nomination_report_view') > -1
    } else {
      return false
    }
  },
  viewReport: state => {
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('view_reports') > -1
    } else {
      return false
    }
  },
  viewLineManagerReport: state => {
    console.log(' state ', state)
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('line-manager-report-access') > -1
    } else {
      return false
    }
  },
  viewExco2Report: state => {
    console.log(' state ', state)
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('exco2-report-access') > -1
    } else {
      return false
    }
  },
  viewHCBPReport: state => {
    console.log(' state ', state)
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('hcbp-report-access') > -1
    } else {
      return false
    }
  },
  viewEmployeeAwards: state => {
    console.log(' state ', state)
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('employee_award_access') > -1
    } else {
      return false
    }
  },
  viewEmployeeAwardsRegional: state => {
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('employee_award_access_regional') > -1
    } else {
      return false
    }
  },
  viewEOMReport: state => {
    console.log(' state ', state)
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('view_eom_report') > -1
    } else {
      return false
    }
  },
  viewEmployeeYearAwards: state => {
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('employee_award_year_access') > -1
    } else {
      return false
    }
  },
  viewEmployeeYearAwardsReport: state => {
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('bu_award_report_access') > -1
    } else {
      return false
    }
  },  
  viewMCGEmployeeYearAwards: state => {
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('mcg-of-the-year') > -1
    } else {
      return false
    }
  },
  viewMCGEmployeeYearAwardsReport: state => {
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('mcg-of-the-year-report') > -1
    } else {
      return false
    }
  },
  viewMCGEmployeeYearAwardsCountReport: state => {
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.roles.indexOf('mcg-report-count-access') > -1
    } else {
      return false
    }
  },
  isContractor: state => {
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.meta.employeeNumber === '0'
    } else {
      return false
    }
  },
  dashedName: state => {
    if (state.userSignedIn && state.currentUser !== null) {
      return state.currentUser.name.replace(/ /g, '-').toLowerCase()
    } else {
      return ''
    }
  }
}

// mutations
const mutations = {
  setCurrentUser (currentState, user) {
    currentState.currentUser = user
  },
  setOtherUser (currentState, user) {
    currentState.otherUser = user
  },
  setcurrentUserCommunityIDs (currentState, ids) {
    currentState.currentUserCommunityIDs = ids
  },
  setCurrentUserCommunities (currentState, communities) {
    currentState.currentUserCommunities = communities
  },
  setOtherUserCommunities (currentState, communities) {
    currentState.otherUserCommunities = communities
  }
}

// actions
const actions = {
  login (context, credentials) {
    return WordpressRestAPI.getJWTToken(credentials.username, credentials.password)
      .then(response => {
        localStorage.setItem('userToken', 'Bearer ' + response.data.token)
        return Promise.resolve()
      })
      .catch(e => {
        console.error(e.response)
        if (e.response.status === 403) {
          // return Promise.reject(new Error('Oops! you entered an ' + e.response.data.code.replace('[jwt_auth] ', '').replace('_', ' ')))
          return Promise.reject(new Error('You entered an incorrect email and/or password'))
        } else {
          return Promise.reject(new Error('Something went wrong with the authentication service. Please try again later'))
        }
      })
  },
  logout (context) {
    localStorage.removeItem('userToken')
    context.commit('setCurrentUser', null)
  },
  userDetails (context) {
    var usernameOptions = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('userToken'),
        'Content-Type': 'application/json'
      },
      json: true
    }
    return WordpressRestAPI.endpointWithAuthetication(usernameOptions, 'users/me?context=edit')
      .then(function (response) {
        context.commit('setCurrentUser', response.data)
        WordpressRestAPI.getViewContent('user_profile?author=' + response.data.id + '&_embed')
          .then(function (categories) {
            context.commit('setCurrentUserCommunities', categories.data[categories.data.length - 1]._embedded['wp:term'][0])
          })
          .catch(function (error) {
            console.error(error)
          })
        return Promise.resolve()
      })
      .catch(function (error) {
        console.error(error)
        return Promise.reject(new Error('User not found'))
      })
  },
  otherUser (context, slug) {
    var apiString = ''
    if (!isNaN(slug) && (function (x) { return (x | 0) === x })(parseFloat(slug))) {
      apiString = '/' + slug
    } else {
      apiString = '?slug=' + slug
    }
    console.log('users' + apiString)
    WordpressRestAPI.getViewContent('users' + apiString)
      .then(response => {
        var userID
        if (response.data.constructor === Array) {
          userID = response.data[0].id
          context.commit('setOtherUser', response.data[0])
        } else {
          userID = response.data.id
          context.commit('setOtherUser', response.data)
        }
        WordpressRestAPI.getViewContent('user_profile?author=' + userID + '&_embed')
          .then(function (categories) {
            context.commit('setOtherUserCommunities', categories.data[0]._embedded['wp:term'][0])
          })
          .catch(function (error) {
            console.error(error)
          })
        return Promise.resolve()
      })
      .catch(error => {
        console.error(error)
        return Promise.reject(new Error('User not found'))
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/UserProfile.js